module.exports = __webpack_public_path__ + "img/specimen2.7b5a403f.png";